import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '.';
import { ContactsMessage, PagedResponse } from '../models';
import { FaqModel } from '../models/faq.model';

@Injectable({
  providedIn: 'root'
})
export class PublicFeedbackService {

  api = `${this.appConfigService.appConfig.SERVER_URL}${this.appConfigService.appConfig.API_STRING}/pub`;
  constructor(
    public http: HttpClient,
    public appConfigService: AppConfigService
  ) { }

  getFaq(): Observable<PagedResponse<FaqModel>> {
    return this.http.get<PagedResponse<FaqModel>>(`${this.api}/dictionaries/faq`);
  }

  postFeedback(contatsMessageModel: ContactsMessage){
    return this.http.post(`${this.api}/dictionaries/feadback`, contatsMessageModel);
  }
}
